import { Component, inject, input, output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent as UiKitFooter } from '@mic-ac/ui-kit';

@Component({
    selector: 'app-footer',
    imports: [ UiKitFooter],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent {
  readonly #router = inject(Router);

  logoFooter = input('')
  /** Logo applicativo nel footer (wordmark bianco) */
  appLogo = input('')
  appLogo2x = input('')
  /** Link al portale Ecomic per il logo applicativo */
  appLogoLink = input('')
  openCookiePreferences = output<void>();

  /** Whether the footer renders its own "back to top" button. */
  showBackToTop = input(true);

  navItems = input<{ label: string; path: string }[]>([]);

  // logo down section

  logoColLeft1 = input('')
  logoColLeft2 = input('')
  logoColLeft3 = input('')
  logoColLeft4 = input('')
  logoColRight = input('')

  logoColLeft1Link = input('')
  logoColLeft2Link = input('')
  logoColLeft3Link = input('')
  logoColLeft4Link = input('')
  logoColRightLink = input('')

  handleFooterAction(action: string) {
    if (action.startsWith('nav:')) {
      this.#router.navigate([action.slice(4)]);
      return;
    } else if (action.startsWith('social_linkedin:')) {
      window.open('https://www.linkedin.com/company/ecomic/');
    }
    switch (action) {
      case 'privacy_info':
        this.#router.navigate(['/privacy-policy']);
        break;
      case 'privacy_policy':
        this.#router.navigate(['/privacy-policy']);
        break;
      case 'cookie_policy':
        this.#router.navigate(['/cookie-policy']);
        break;
      case 'cookie_preferences':
        this.openCookiePreferences.emit();
        break;
      case 'terms_conditions':
        this.#router.navigate(['/termini-condizioni']);
        break;
      case 'crediti':
        this.#router.navigate(['/approfondimento']);
        break;
      case 'scroll_top':
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      case 'contact_form':
        window.dispatchEvent(new CustomEvent('open-contact-form'));
        break;
      // Handle other actions (router navigation etc) if needed
    }
  }
}
